//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import RoleListView from "@/views/Roles/list"
import RoleCreateView from "@/views/Roles/create"
import RoleUpdateView from "@/views/Roles/update"

//
export default {
    path: "roles",
    component: ModuleLayout,
    children: [
        {
            name: "role-list",
            path: "",
            component: RoleListView,
        },
        {
            name: "role-create",
            path: "create",
            component: RoleCreateView,
            meta: {
                title: "Crear Rol"
            },
        },
        {
            name: "role-update",
            path: ":id",
            component: RoleUpdateView,
            meta: {
                title: "Datos de Rol"
            },
        },
    ],
    meta: {
        title: "Roles"
    },
}